import React from 'react'
import useNavigateTo from 'hooks/useNavigateTo'
import { AppFC } from 'types'

import { getRoleFromPath } from 'utils/helper'
import { ROLES } from 'config'
import ActionCard from 'components/Common/ActionCard'
import { IUpcomingEventsProps } from 'components/AppDashboard/interfaces'
import { AppDashboardUpcomingEventsItems } from 'components/AppDashboard/AppDashboardUpcomingEventsItems/AppDashboardUpcomingEventsItems'
import { AppointmentsSkeletonLoader } from './AppointmentsSkeletonLoader.component'

const AppDashboardUpcomingEvents: AppFC<IUpcomingEventsProps> = ({
  events = [],
  className = '',
  noEventsMessage = '',
  loading = false,
  showInternalMeetingsOnly = false,
}) => {
  const navigate = useNavigateTo('calendar')
  const userRole = getRoleFromPath()

  const noEventsScheduled = !loading && events.length === 0

  return (
    <div>
      {loading ? (
        <AppointmentsSkeletonLoader />
      ) : (
        <div className="">
          {noEventsScheduled && (
            <p className="italic text-black-light text-lg sm:text-xl -mt-2">
              No {userRole === ROLES.V2 ? 'appointments yet!' : 'appointments today'}
            </p>
          )}
          <div className="space-y-4">
            {noEventsScheduled ? (
              <ActionCard onClick={() => navigate()}>
                <div>
                  <p className="leading-6 font-semibold text-lg">{noEventsMessage}</p>
                </div>
              </ActionCard>
            ) : (
              <AppDashboardUpcomingEventsItems
                events={events}
                showInternalMeetingsOnly={showInternalMeetingsOnly}
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default AppDashboardUpcomingEvents
